import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookVersionResponse } from '../../responses/platform/book-version.response';

@Injectable({
    providedIn: 'root'
})
export class BookVersionService extends CommonService {
    constructor(private http: HttpClient) {
        super();
    }

    public GetBookVersion(idBookVersion: number, idStatusVersion: number): Observable<BookVersionResponse> {
        return this.http
            .get<BookVersionResponse>(environment.urlApiPlatform + "BookVersion/idBookVersion/" + idBookVersion + "/idStatusVersion/" + idStatusVersion, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
